module.exports = __webpack_public_path__ + "img/sparks-green-medium.ddfce9ae.png";